import ContactDetails from "./ContactDetails";

export default ContactDetails;


// WEBPACK FOOTER //
// src/modules/screens/settings/ContactDetails/components/index.js